import React, { Component } from 'react'
import { Route, Switch } from 'react-router-dom'
import TipoFormularioSecuenciaGrid from './TipoFormularioSecuenciaGrid'
import TipoFormularioSecuenciaAbm from './TipoFormularioSecuenciaAbm.js'
import {FormattedMessage, injectIntl} from 'react-intl';

class TipoFormularioSecuencia extends Component {
	render() {
	    return (
			<div className="content-wrapper">
				<div className="content-header row">
					<div className="content-header-left col-md-6 col-12 mb-2">
      					<h3 className="content-header-title"><FormattedMessage id="tipoFormularioSecuencia.label_secuencias_checklist" defaultMessage="Secuencias"/></h3>
      				</div>
				</div>
				<div className="content-body">
					<Switch>
						<Route exact path={`${this.props.match.url}`} component={TipoFormularioSecuenciaGrid} />
						<Route exact path={`${this.props.match.url}/add`} render={(props) => <TipoFormularioSecuenciaAbm {...props} intl={this.props.intl} action="ADD" />} />
						<Route exact path={`${this.props.match.url}/:id/edit`} render={(props) => <TipoFormularioSecuenciaAbm {...props} intl={this.props.intl} action="EDIT" />} />
						<Route path={`${this.props.match.url}/:id`} render={(props) => <TipoFormularioSecuenciaAbm {...props} intl={this.props.intl} action="VIEW" />} />
					</Switch>
				</div>
			</div>
	    );
  	}
}

export default injectIntl(TipoFormularioSecuencia);
